import { TextAreaEntry as TAE } from '@bpmn-io/properties-panel';
import type { FunctionalComponent, VNode } from '@bpmn-io/properties-panel/preact';
import type { Element } from 'bpmn-js/lib/model/Types';

export const TextAreaEntry = TAE as <E extends Element = Element>(props: {
    autoResize?: boolean;
    debounce: <T extends (...args: unknown[]) => unknown>(fn: T) => T;
    description?: string;
    disabled?: boolean;
    element: E;
    getValue: (element: E) => string;
    id: string;
    label?: string;
    monospace?: boolean,
    onBlur?: (event: FocusEvent) => void;
    onFocus?: (event: FocusEvent) => void;
    placeholder?: string;
    rows?: number,
    setValue: (value: string, validationError?: unknown) => void;
    tooltip?: string | FunctionalComponent;
    validate?: (value: string) => string | undefined | void;
}) => VNode;
